import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { format } from 'date-fns';
import { BsModalRef } from 'ngx-bootstrap/modal';

import { QuillHelper } from '../../../../../../shared/helpers/quill.helper';
import { SharedToasterService } from '../../../../../../shared/services/shared-toaster.service';
import { AssignmentDetailsModel } from '../../../models/assignment-details.model';
import { AssignmentParticipantContactingPostModel } from '../../../models/assignment-participants/assignment-participants-contacting.model';
import { AssignmentDetailsStateService } from '../../../services/assignment-details-state.service';
import { AssignmentsParticipantService } from '../../../services/assignments-participants.service';

@Component({
    selector: 'app-assignment-participants-contacting-modal',
    templateUrl: './assignment-participants-contacting-modal.component.html',
    styleUrl: './assignment-participants-contacting-modal.component.scss'
})
export class AssignmentContactParticipantsModalComponent implements OnInit {
    assignmentContactingParticipantsModel!: AssignmentParticipantContactingPostModel
    participantContactForm!: FormGroup;
    assignmentId!: number;

    protected subjectText: string = "";
    protected editorModule: any;
    protected errorMessage: string | null = null;
    protected isLoading: boolean = false;

    constructor(
        private formBuilder: FormBuilder,
        private assignmentParticipantService: AssignmentsParticipantService,
        private bsModalRef: BsModalRef,
        private assignmentDetailsStateService: AssignmentDetailsStateService,
        private toasterService: SharedToasterService
    ) { }

    ngOnInit(): void {
        this.initForm();
        this.setModules();
    }

    public saveForm(): void {
        if (this.participantContactForm.valid) {
            this.sendMessageToParticipants();
        } else {
            this.participantContactForm.markAllAsTouched();
        }
    }

    private sendMessageToParticipants(): void {
        this.errorMessage = null;
        this.isLoading = true;

        this.assignmentContactingParticipantsModel = {
            subject: this.participantContactForm.value.subject,
            message: QuillHelper.normalize(this.participantContactForm.value.message)
        };

        this.assignmentParticipantService.sendMessageToAssignmentParticipants(this.assignmentId, this.assignmentContactingParticipantsModel)
            .subscribe({
                next: () => {
                    this.toasterService.showGeneralEmailSendingSuccess();
                    this.bsModalRef.hide();
                },
                error: (error) => {
                    this.isLoading = false;
                    this.toasterService.showGeneralEmailSendingError();
                }
            });
    }

    private initForm(): void {
        this.assignmentDetailsStateService.assignmentDetails.subscribe({
            next: (assignment) => {

                if (assignment) {
                    this.subjectText = this.createMailSubject(assignment);
                    this.participantContactForm = this.formBuilder.group({
                        subject: [this.subjectText, Validators.required],
                        message: ['', Validators.required]
                    });
                }
            }
        });
    }

    private createMailSubject(assignment: AssignmentDetailsModel): string {

        const sport = assignment?.sportName;
        const lessonTitle = assignment?.title;
        const fromDate = format(new Date(assignment.from), 'dd.MM.yy');
        const time = `${format(new Date(assignment.from), "HH:mm")} - ${format(new Date(assignment.to), "HH:mm")}`;

        return `${sport}, ${lessonTitle}, ${fromDate}, ${time}`;
    }

    private setModules() {
        this.editorModule = {
            toolbar: [
                [{ 'header': 1 }, { 'header': 2 }],
                ['bold', 'italic', 'underline', 'strike'],
                [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                ['link']
            ]
        };
    }
}
